import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'navigation-apps-sidebar-plan.menu.planning-container.scenario-switcher.header',
		defaultMessage: 'Scenarios',
		description: 'Header for the scenario list',
	},
	manageScenarios: {
		id: 'navigation-apps-sidebar-plan.menu.planning-container.scenario-switcher.manage-scenarios',
		defaultMessage: 'Manage scenarios',
		description: 'Dropdown item which takes users to scenarios settings page',
	},
});
